import { RootState } from 'redux/types';
import { Fee } from '.';

export const getFeesByIds =
  (ids: string[]) =>
  (store: RootState): Array<Fee | undefined> => {
    return ids.map(id => store.fee.entities[id]);
  };
